import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from '../../app-config';

@Component({
  selector: 'app-f621-cf848-df74452',
  templateUrl: './f621-cf848-df74452.component.html'
})
export class F621CF848DF74452Component implements OnInit {

  constructor(private config: AppConfig, private router: Router) { }
  IsPortal = this.config.IsPortal;
  documentPath;

  ngOnInit() {
    if (this.IsPortal)
      this.documentPath = this.config.TravelClearanceRoutingURLPortal
    else
      this.router.navigateByUrl('/');
  }

}
